const AssigneeInfos = Vue.component('assigneeinfos', {
    template: `
        <div>
            <div class="row title">
                <h4>
                    {{ (assigneeType == 'competitor')? $language.competitor:$language.pa }}: {{ assignee }}
                </h4>
                <a class="snapshotLink" :href="$setupPath + '../assigneeSnapshot/public/?assignee=' + encodeURI(assignee)" target="_blank" title="Link to the full snapshot">
                    Snapshot <img :src="$setupPath + 'components/images/logos/analytics/favicon.ico'" alt="snapshot logo">
                </a>
                <companylinks v-bind:company="assignee" class="companyLinks"></companylinks>

            </div>
            <div class="main" id="assigneeInfos">
                <div class="row">
                    <div class="col-xl-5 col-lg-7 summary">
                        <div class="row" v-for="(value, categorie) in assigneeData.generalInfos">
                            <div class="col-8">
                                <b v-if="categorie == 'applications'"> {{ $language.appNum }} </b>
                                <b v-else-if="categorie == 'families'"> {{ $language.famNum }} </b>
                                <b v-else-if="categorie == 'publications'"> {{ $language.pubNum }} </b>
                            </div>
                            <div class="col-4">
                                {{ value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div id="juridisctionsChart"></div>
                    </div>
                    <div class="col-md-6">
                        <div id="yearsChart"></div>
                    </div>
                </div>
            </div>
        </div>
    `,

    computed: {
        family() {
            return this.$route.params.family;
        },
        assignee() {
            // return this.$route.params.assigneeName || this.$store.state.pa;

            if (this.$route.params.assigneeName) {
                return this.$route.params.assigneeName
            } else {
                return this.$store.state.pa;
            }
        },
        assigneeType() {
            return this.$store.state.assigneeType;
        }
    },

    data: function() {
        return {
            assigneeData: {}
        };
    },

    watch: {
        assignee: function(newAssignee, oldAssignee) {
            this.onNewAssignee();
        }
    },

    mounted: function() {
        this.onNewAssignee();
    },

    methods: {
        onNewAssignee: function() {

            //used to prevent to show the loading state if the assignee is already used
            this.$store.commit('changeLoadedAssignee', this.assignee);

            if (!this.$store.state.assigneeInfos[this.assignee]) {

                //get assignee informations
                axios.get('?page=getData&action=assignee', {
                        params: {
                            assignee: this.assignee
                        }
                    })
                    .then(response => {

                        this.assigneeData = response.data;
                        this.$store.commit('storeAssigneeInfos', {
                            assignee: this.assignee,
                            data: response.data
                        })
                        this.drawChart();
                    })
                    .catch(err => {
                        console.log(err);
                    });

            } else {

                this.assigneeData = this.$store.state.assigneeInfos[this.assignee];
                this.drawChart();
            }

        },

        drawChart: function() {

            Highcharts.setOptions({
                colors: ['#afd8f8', '#f6bd10', '#8cbb02', '#ff8f48', '#028f8f', '#d64848', '#8f488f', '#5a8629', '#b4ab03', '#038fd6', '#9e0b10', '#a287bf', '#cd6904', '#fdc78b', '#ada205', '#f2707f', '#fff205', '#0558a8', '#f79721', '#cd3805']
            });

            //make the jurisdictions data usable in highcharts
            var jurisdictionData = [];
            var jurisdictions = [];

            this.assigneeData.jurisdictions.forEach(function(jurisdiction) {
                jurisdictionData.push({
                    code: jurisdiction.jurisdiction,
                    y: jurisdiction.total,
                    name: countries.codes[jurisdiction.jurisdiction]
                });
                jurisdictions.push(countries.codes[jurisdiction.jurisdiction] + ' (' + jurisdiction.jurisdiction + ')');
            });

            var jurisdictionsChart = Highcharts.chart('juridisctionsChart', {
                chart: {
                    type: 'column'
                },

                title: {
                    text: this.$language.topJuris,
                    useHTML: true
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                xAxis: {
                    crosshair: true,
                    ceiling: 4,
                    categories: jurisdictions
                },

                legend: {
                    enabled: false
                },

                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: this.$language.applications
                    }
                },

                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: '{point.name}',
                    colorByPoint: true,
                    data: jurisdictionData,
                    tooltip: {
                        pointFormat: this.$language.applications + ': {point.y}'
                    }
                }],

            });

            //make the year data usable in highcharts
            var applicationsData = [];
            var grantsData = [];
            var start = [];


            for (var year in this.assigneeData.years) {
                if (this.assigneeData.years.hasOwnProperty(year)) {
                    start.push(year);
                    applicationsData.push([year, this.assigneeData.years[year].applications]);
                    grantsData.push([year, this.assigneeData.years[year].grants]);
                }
            }

            Highcharts.chart('yearsChart', {
                chart: {
                    type: 'spline'
                },

                title: {
                    text: this.$language.appNGrant,
                    useHTML: true
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                yAxis: {
                    allowDecimals: false,
                    title: {
                        text: this.$language.appNGrant
                    }
                },

                plotOptions: {
                    series: {
                        pointStart: parseInt(start[0])
                    }
                },


                legend: {
                    enabled: false
                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: this.$language.applications,
                    data: applicationsData

                }, {
                    name: this.$language.grants,
                    data: grantsData
                }]
            });

            this.$store.commit('hideLoading');

        }
    }
});
